document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.style.display === 'block';
      nav.style.display = open ? 'none' : 'block';
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  // Load more (featured collection grid)
  document.querySelectorAll('.load-more-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = btn.closest('.container').querySelector('.product-grid');
      if (!grid) return;
      grid.querySelectorAll('.product-card.is-hidden-more').forEach(function (card) {
        card.classList.remove('is-hidden-more');
      });
      btn.style.display = 'none';
    });
  });

  // Collection circle carousel arrows
  document.querySelectorAll('.collection-carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.collection-circles');
    var prev = wrap.querySelector('.carousel-prev');
    var next = wrap.querySelector('.carousel-next');
    if (!track) return;
    var scrollAmount = 260;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
  });

  // Cart page: quantity change auto-submits the update form
  var cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    cartForm.querySelectorAll('.qty-input').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  // Product gallery: thumbnails + arrows
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('.thumb');
    var slides = gallery.querySelectorAll('.main-image');
    var prev = gallery.querySelector('.gallery-prev');
    var next = gallery.querySelector('.gallery-next');
    if (!slides.length) return;
    var current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  });

  // Customization block: logo upload toggle + live font preview
  var uploadSelect = document.getElementById('UploadLogoSelect');
  var logoRow = document.getElementById('LogoFileRow');
  if (uploadSelect && logoRow) {
    function toggleLogoRow() { logoRow.style.display = uploadSelect.value === 'Yes' ? '' : 'none'; }
    uploadSelect.addEventListener('change', toggleLogoRow);
    toggleLogoRow();
  }

  var nameInput = document.getElementById('CustomName');
  var fontSelect = document.getElementById('FontSelect');
  var previewText = document.getElementById('FontPreviewText');
  function updatePreview() {
    if (!previewText) return;
    var typed = nameInput ? nameInput.value.trim() : '';
    previewText.textContent = typed ? typed : (previewText.getAttribute('data-default') || '');
    if (fontSelect) previewText.style.fontFamily = "'" + fontSelect.value + "', sans-serif";
  }
  if (nameInput) nameInput.addEventListener('input', updatePreview);
  if (fontSelect) { fontSelect.addEventListener('change', updatePreview); }
  updatePreview();

  // Product variant option selection
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var variantsJSON = document.getElementById('ProductVariantsJSON');
  var variants = variantsJSON ? JSON.parse(variantsJSON.textContent) : [];
  var select = document.getElementById('ProductVariantSelect');
  var addBtn = form.querySelector('.add-to-cart-btn');
  var orderBtn = document.getElementById('OrderNowBtn');
  var priceCurrent = document.querySelector('.price-current');
  var priceCompare = document.querySelector('.price-compare');
  var optionGroups = form.querySelectorAll('.option-values');

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    amount = parts.join('.');
    var format = window.shopMoneyFormat || 'Rs. {{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function selectedOptions() {
    var result = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.option-value.is-selected');
      result.push(active ? active.getAttribute('data-value') : null);
    });
    return result;
  }

  function findVariant() {
    var opts = selectedOptions();
    return variants.find(function (v) {
      var vals = [v.option1, v.option2, v.option3];
      return opts.every(function (val, i) { return val === null || vals[i] === val; });
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;
    if (select) select.value = variant.id;
    if (priceCurrent) priceCurrent.textContent = money(variant.price);
    if (priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = money(variant.compare_at_price);
        priceCompare.style.display = '';
      } else {
        priceCompare.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (orderBtn) {
      orderBtn.disabled = !variant.available;
      orderBtn.textContent = variant.available ? 'Order Now' : 'Sold Out';
    }

    // Variant image switching \u2014 matched by position, not id. Shopify's
    // featured_image.position (1-indexed) lines up with the order product.media
    // was looped over to build .main-image/.thumb, so position-1 is the index.
    if (variant.featured_image) {
      var pos = variant.featured_image.position - 1;
      var gallery = document.querySelector('.product-gallery');
      if (gallery) {
        var slides = gallery.querySelectorAll('.main-image');
        var thumbs = gallery.querySelectorAll('.thumb');
        if (pos >= 0 && pos < slides.length) {
          slides.forEach(function (s, i) { s.classList.toggle('is-active', i === pos); });
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === pos); });
        }
      }
    }
  }

  optionGroups.forEach(function (group) {
    group.querySelectorAll('.option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.option-value').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateUI();
      });
    });
  });

  // Order Now: native full form submission (handles variant, properties, name,
  // font, logo file, notes correctly, including file uploads). return_to tells
  // Shopify's native cart/add handler to land the browser on checkout afterward.
  // A safety timeout guarantees the button never stays stuck on "Processing...".
  if (orderBtn) {
    orderBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var originalText = orderBtn.textContent;
      orderBtn.textContent = 'Processing...';
      var resetTimer = setTimeout(function () {
        orderBtn.disabled = false;
        orderBtn.textContent = originalText;
      }, 6000);
      try {
        var existing = form.querySelector('input[name="return_to"]');
        if (existing) existing.remove();
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        input.value = '/checkout';
        form.appendChild(input);
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      } catch (err) {
        clearTimeout(resetTimer);
        orderBtn.disabled = false;
        orderBtn.textContent = originalText;
        alert('Could not process order. Please try Add to Cart instead.');
      }
    });
  }
});
